import { Fragment } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';

interface ICardContentMaterial {
  type: string;
}

export function CardContentMaterial({ type }: ICardContentMaterial) {
  const material_type = () => {
    if (type === 'mapa_mental') {
      return 'Mapa mental';
    }

    if (type === 'dossie') {
      return 'Dossiê';
    }

    if (type === 'exercicio') {
      return 'Lista de exercício';
    }

    return 'Apostila';
  };

  return (
    <Fragment>
      <Typography
        size='small'
        className='transition delay-100 ease-in-out group-hover:text-card-color-default'
      >
        {material_type()}
      </Typography>
    </Fragment>
  );
}
